import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { formatPrice } from '../data/products';
import { useProductsStore } from '../store/productsStore';
import { useStore } from '../store/useStore';
import ProductCard from '../components/ProductCard';

const FavoritesPage: React.FC = () => {
  const { t } = useTranslation();
  const { favorites } = useStore();
  const products = useProductsStore((state) => state.products);
  const favoriteProducts = products.filter(p => favorites.includes(p.id));

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-gradient-to-r from-[#0A0A0A] to-[#1a1a2e] text-white py-10 sm:py-14">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl sm:text-4xl font-black">❤️ {t('nav.favorites')}</h1>
          <p className="text-gray-400 mt-2">{favoriteProducts.length} ürün favorilerinizde</p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
        {favoriteProducts.length === 0 ? (
          <div className="text-center py-16">
            <div className="text-6xl mb-4">💔</div>
            <p className="text-gray-500 text-lg mb-4">Henüz favori ürününüz yok</p>
            <Link
              to="/magaza"
              className="inline-flex items-center gap-2 px-6 py-3 bg-[#E31E24] text-white font-bold rounded-xl hover:bg-[#c41a1f] transition-colors"
            >
              🛒 Alışverişe Başla
            </Link>
          </div>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6">
            {favoriteProducts.map((product) => (
              <ProductCard key={product.id} product={product} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default FavoritesPage;
